import { Text } from '@bizzabo/design-system';
import { UserData, UserPreview } from '@bizzabo/entities';

import MeetingNowItem from '../MeetingNowItem';
import MeetingInvitesItem from '../MeetingInvitesItem';
import ScheduledItem from '../ScheduledItem';
import AwaitingItem from '../AwaitingItem';
import { ScheduledMeeting } from '../../types';
import HistoryItem from '../HistoryItem';
import CancelledItem from '../CancelledItem';

interface ManageListProps {
    meetingList: Record<string, ScheduledMeeting[]>;
    users: UserPreview[];
    currentUser: UserData;
}

const ManageList: React.FC<ManageListProps> = ({ meetingList, users, currentUser }) => {
    if (!meetingList) {
        return null;
    }

    const {
        meetingNow,
        meetingInvites,
        upcomingMeetings,
        pendingMeetings,
        historyMeetings,
        cancelledMeetings,
    } = meetingList;

    const getUser = (users: UserPreview[], meeting: ScheduledMeeting) => {
        const guestParticipant = meeting.participants.find(
            participant => participant.userProfileId !== currentUser.userProfileId
        );
        return users.find(user => user.userProfileId === guestParticipant.userProfileId);
    };
    return (
        <>
            {meetingNow.length > 0 && (
                <>
                    <Text variant="t50">Next up</Text>
                    <div>
                        {meetingNow.map(meeting => {
                            const user = getUser(users, meeting);
                            return (
                                <MeetingNowItem
                                    key={meeting.id}
                                    meeting={meeting}
                                    currentUser={currentUser}
                                    user={user}
                                />
                            );
                        })}
                    </div>
                </>
            )}

            {meetingInvites.length > 0 && (
                <>
                    <Text variant="t50">Meeting Invites</Text>
                    <div>
                        {meetingInvites.map(meeting => {
                            const user = getUser(users, meeting);
                            return (
                                <MeetingInvitesItem
                                    key={meeting.id}
                                    meeting={meeting}
                                    user={user}
                                />
                            );
                        })}
                    </div>
                </>
            )}

            {upcomingMeetings.length > 0 && (
                <>
                    <Text variant="t50">Scheduled</Text>
                    <div>
                        {upcomingMeetings.map(meeting => {
                            const user = getUser(users, meeting);
                            return (
                                <ScheduledItem
                                    key={meeting.id}
                                    meeting={meeting}
                                    currentUser={currentUser}
                                    user={user}
                                />
                            );
                        })}
                    </div>
                </>
            )}

            {pendingMeetings.length > 0 && (
                <>
                    <Text variant="t50">Awaiting confirmation</Text>
                    <div>
                        {pendingMeetings.map(meeting => {
                            const user = getUser(users, meeting);
                            return (
                                <AwaitingItem
                                    key={meeting.id}
                                    meeting={meeting}
                                    currentUser={currentUser}
                                    user={user}
                                />
                            );
                        })}
                    </div>
                </>
            )}

            {historyMeetings.length > 0 && (
                <>
                    <Text variant="t50">Meeting history</Text>
                    <div>
                        {historyMeetings.map(meeting => {
                            const user = getUser(users, meeting);
                            return <HistoryItem key={meeting.id} meeting={meeting} user={user} />;
                        })}
                    </div>
                </>
            )}

            {cancelledMeetings.length > 0 && (
                <>
                    <Text variant="t50">Cancelled</Text>
                    <div>
                        {cancelledMeetings.map(meeting => {
                            const user = getUser(users, meeting);
                            return (
                                <CancelledItem
                                    key={meeting.id}
                                    meeting={meeting}
                                    user={user}
                                    currentUser={currentUser}
                                />
                            );
                        })}
                    </div>
                </>
            )}
        </>
    );
};

export default ManageList;
